export const CHURN_CATEGORY_GROUPS = [
  {
    family: "Résultats",
    categories: [
      "Pas assez de RDV (volume insuffisant)",
      "RDV hors cible / non qualifiés",
      "Trop de no-show",
      "Aucune signature / pas de closing",
      "Pas de ROI / rentabilité insuffisante",
      "Coût par lead / par RDV trop élevé",
    ],
  },
  {
    family: "Prix & modèle",
    categories: [
      "Refus du modèle fixe / frais fixes",
      "Refus de la nouvelle infra",
      "Budget trop juste / prix trop élevé",
    ],
  },
  {
    family: "Fit & maturité",
    categories: [
      "Cible/offre inadaptée à l'outbound (B2C, niche)",
      "Client pas prêt / pas mature pour l'outbound",
    ],
  },
  {
    family: "Décision client",
    categories: [
      "Internalisation de la prospection",
      "Réorientation stratégique / priorités",
      "Passage à un concurrent / autre canal",
    ],
  },
  {
    family: "Pause",
    categories: [
      "Pause saisonnière / estivale",
      "Mise en pause temporaire",
    ],
  },
  {
    family: "Situation client",
    categories: [
      "Difficultés financières / fermeture",
      "Interlocuteur indisponible (départ, maladie)",
      "Capacité d'absorption limitée",
    ],
  },
  {
    family: "Relation & exécution",
    categories: [
      "Relation dégradée / client difficile / injoignable",
      "Impayé / litige de facturation",
      "Mauvais démarrage / défaillance Oliverlist",
      "Problème technique plateforme",
    ],
  },
  {
    family: "Autre",
    categories: ["Autre (à préciser)"],
  },
];
